// extracted by mini-css-extract-plugin
export default {"input":"Input_input__V0-sX","outlined":"Input_outlined__GIPtS","default":"Input_default__jqLcm"};